import { useTranslation } from "react-i18next";
import { NubeskIcons } from "components/atoms/index";
import FilterArea from "components/molecules/FilterGroup/FilterArea";

const InitialProcess = ({ bussy, onBussy, onChange, prefix }) => {
  const { t } = useTranslation();
  return (
    <>
      {!bussy ?
        <>
          <span className={`${prefix}__paste-label`}>
            {t("module:phototool.fetchPc9.modal.placeholder")}
          </span>
          <FilterArea
            disabled={bussy}
            onBussy={onBussy}
            onChange={(a) => {
              if (a) {
                onChange(a);
              }
            }}
          />
        </>
      :
        <div className={`${prefix}__paste-loading`}>
          <NubeskIcons className="u-spin" icon="spin" size="5rem" />
          <span>{t("module:phototool.fetchPc9.modal.searching")}</span>
        </div>
      }
    </>
  );
};

export default InitialProcess;
